<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
		<g :style="`fill:${active ? 'white' : globalColors.primary};`">
			<path d="M12.122 19.122a.417.417 0 1 0 .59.59.417.417 0 0 0-.59-.59z"/>
			<path d="M23.898 18.21l-3.71-3.151a.501.501 0 0 0-.055-.04 2.431 2.431 0 0 0-3.04.333l-2.023 2.02a.488.488 0 0 1-.533.107c-2.285-.944-4.161-2.366-5.578-4.224-1.08-1.418-1.47-2.544-1.522-2.703a.485.485 0 0 0-.03-.1.485.485 0 0 1 .107-.532L9.537 7.9a2.424 2.424 0 0 0 .318-3.06l-2.68-3.72A2.445 2.445 0 0 0 3.393.714l-.405.405-.001.001L1.54 2.566C-.185 4.289-.467 6.879.724 10.055c1.02 2.72 3.063 5.698 5.752 8.384 2.752 2.749 5.813 4.827 8.62 5.852 2.778 1.013 5.732 1.138 7.824-.951l1.364-1.363a2.44 2.44 0 0 0-.386-3.766zm-4.316-2.384l3.707 3.15a.481.481 0 0 0 .054.04c.792.503.912 1.61.25 2.271l-.102.101-6.324-4.73.617-.616a1.458 1.458 0 0 1 1.798-.216zM6.358 1.655l.016.023 2.679 3.719c.364.582.28 1.325-.207 1.811l-.598.597L3.969 1.52l.115-.114a1.467 1.467 0 0 1 2.274.249zm9.073 21.718c-2.675-.976-5.61-2.974-8.264-5.625-2.592-2.589-4.555-5.443-5.527-8.036C.91 7.766.42 5.066 2.23 3.257l1.035-1.034 4.278 6.285-.721.721c-.41.41-.54 1.016-.335 1.555.154.632.864 1.945 1.58 2.913 1.054 1.423 2.967 3.392 6.096 4.684.55.227 1.176.103 1.597-.317l.708-.708 6.324 4.73-.564.564c-1.942 1.94-4.769 1.464-6.798.723z"/>
			<path d="M11.482 18.28c-.572-.468-1.56-1.274-2.081-1.775-1.278-1.226-2.618-2.713-3.415-3.787a.566.566 0 0 0-.753-.128.485.485 0 0 0-.137.704c1.005 1.355 2.482 2.912 3.528 3.917.55.529 1.548 1.341 2.144 1.83a.568.568 0 0 0 .764-.047.483.483 0 0 0-.05-.713z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'phone-component',
	props: {
		active: {
			default: false,
			type: Boolean,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/phone-component.vue